import { type LeaderboardDto, type LeaderboardRowDto, kitById, leagueOf } from '@penalty-cup/shared';
import { useCallback, useEffect, useState } from 'react';
import { api } from '../api.js';
import { useApp } from '../store.js';
import { useBackButton } from '../telegram-back.js';

const MEDALS: Record<number, string> = { 1: '🥇', 2: '🥈', 3: '🥉' };

function Row({ row }: { row: LeaderboardRowDto }) {
  const league = leagueOf(row.rating).league;
  return (
    <li className={`lb__row ${row.isYou ? 'lb__row--you' : ''}`}>
      <span className="lb__rank">{MEDALS[row.rank] ?? row.rank}</span>
      <span className="lb__kit" style={{ background: kitById(row.kit).color }} aria-hidden="true" />
      <span className="lb__name">
        {row.name}
        {row.isYou && ' (вы)'}
        {row.tournamentsWon > 0 && <span className="lb__cups"> · 🏆 {row.tournamentsWon}</span>}
      </span>
      <span className="lb__rating" style={{ color: league.color }}>
        {row.rating}
      </span>
    </li>
  );
}

/** Глобальный топ по рейтингу; своё место — подсвечено, вне топа — закреплено внизу. */
export function Leaderboard() {
  const token = useApp((s) => s.token);
  const setView = useApp((s) => s.setView);
  const back = useCallback(() => setView(null), [setView]);
  useBackButton(back);
  const [data, setData] = useState<LeaderboardDto | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!token) return;
    let alive = true;
    api.leaderboard(token).then(
      (d) => alive && setData(d),
      () => alive && setFailed(true),
    );
    return () => {
      alive = false;
    };
  }, [token]);

  const youInTop = data?.top.some((r) => r.isYou);
  return (
    <main className="screen lb screen--nav">
      <h1 className="screen__title">Лидерборд</h1>
      <p className="screen__lead">
        {data
          ? `Игроков в рейтинге: ${data.total}`
          : failed
            ? 'Не удалось загрузить. Попробуйте позже'
            : 'Загружаем…'}
      </p>
      {data && data.top.length === 0 && (
        <p className="screen__lead">Пока никто не сыграл — станьте первым!</p>
      )}
      {data && (
        <ol className="lb__list">
          {data.top.map((r) => (
            <Row key={r.rank} row={r} />
          ))}
        </ol>
      )}
      {data?.you && !youInTop && (
        <ol className="lb__list lb__list--you">
          <Row row={data.you} />
        </ol>
      )}
      {data && !data.you && <p className="screen__lead">Сыграйте матч, чтобы попасть в рейтинг</p>}
      <button type="button" className="link" onClick={back}>
        На главный
      </button>
    </main>
  );
}
